import { render, staticRenderFns } from "./DisplayAnalysis.vue?vue&type=template&id=221a49fb&scoped=true"
import script from "./DisplayAnalysis.vue?vue&type=script&lang=ts"
export * from "./DisplayAnalysis.vue?vue&type=script&lang=ts"
import style0 from "./DisplayAnalysis.vue?vue&type=style&index=0&id=221a49fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a49fb",
  null
  
)

export default component.exports